import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"
import useSWR from "swr"
import type { UserBankAccountListItem, UserBankAccountListQuery } from "../types"

export interface GetUserBankAccountsApiResponse {
  bankAccounts: UserBankAccountListItem[]
  totalCount: number
  page: number
  perPage: number
}

const buildUrl = (query: UserBankAccountListQuery) => {
  const params = new URLSearchParams()
  if (query.search) params.set("search", query.search)
  params.set("page", String(query.page))
  return `${SMOOTH_LINE_API_URL}/base_api/smoother/screen/user_bank_accounts?${params.toString()}`
}

export const useGetUserBankAccounts = (query: UserBankAccountListQuery) => {
  const { getWithToken } = useSmoothApi()
  const url = buildUrl(query)

  const fetcher = async (fetchUrl: string): Promise<GetUserBankAccountsApiResponse> => {
    const response = await getWithToken(fetchUrl)
    return response.data as GetUserBankAccountsApiResponse
  }

  const swr = useSWR(url, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: true,
    keepPreviousData: true,
  })

  return {
    bankAccounts: swr.data?.bankAccounts ?? [],
    totalCount: swr.data?.totalCount ?? 0,
    perPage: swr.data?.perPage ?? 200,
    isLoading: swr.isLoading,
    error: (swr.error as Error | undefined) ?? null,
  }
}
